import React, { useEffect, useState } from "react";
import Text from "antd/lib/typography/Text";
import { Image, Progress } from "antd";
import styles from "../../styles/dashboard.module.scss";
import barchart from "../../data/barchart.json";
import TeamEngagementBar from "../../components/TeamEngagementBar";
import StackedBarWellness from "../../components/StackedBarWellness";
import StackedBarHappiness from "../../components/StackedBarHappiness";
import MoodLineChart from "../../components/MoodLineChart";

import { useB2BContext } from "../../context/ContextB2B";
import moment from "moment";
import { authSVC } from "../../services";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

function InsightsSingle() {
  const [pieChartData, setpieChartData] = useState<any[]>([]);
  const [departmentLevel, setdepartmentLevel] = useState<any[]>([]);
  const [overallLevel, setoverallLevel] = useState<any>();
  const [yearlyWellnessIndexes, setYearlyWellnessIndexes] = useState<any>([]);
  const [yearlyEngagementIndexes, setYearlyEngagementIndexes] = useState<any>(
    []
  );
  const [yearlyHappinessIndexes, setYearlyHappinessIndexes] = useState<any>([]);
  const [yearlyMoodOverview, setYearlyMoodOverview] = useState<any[]>([]);
  const [wellnessDeptChartData, setWellnessDeptChartData] = useState<any>();
  const [happinessDeptChartData, setHappinessDeptChartData] = useState<any>();
  const { getUserByID } = useB2BContext();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [year, setYear] = useState(new Date().getFullYear());

  const changeYear = (offset: any) => {
    setYear((prevYear) => prevYear + offset);
  };

  const TeamName = searchParams.get("department");

  useEffect(() => {
    const year: any = moment().format("yyyy");
    if (getUserByID) {
      authSVC
        .yearlyWellnessIndexes({
          year: year,
          department: TeamName,
          company: getUserByID?.company,
        })
        .then((res: any) => {
          setYearlyWellnessIndexes(res?.data);
          // console.log(res.data.percentage, "setYearlyWellnessIndexes");
        })
        .catch((err: any) => {
          //message.error(err.response?.data?.error);
        });

      authSVC
        .yearlyHappinessIndexes({
          year: year,
          department: TeamName,
        })
        .then((res: any) => {
          setYearlyHappinessIndexes(res?.data);
          console.log(res.data.data, "setYearlyHappinessIndexes");
        })
        .catch((err: any) => {
          //message.error(err.response?.data?.error);
        });

      authSVC
        .yearlyEngagementIndexes({
          year: year,
          department: TeamName,
        })
        .then((res: any) => {
          setYearlyEngagementIndexes(res?.data);
          console.log(res.data.data, "yearlyEngagementIndexes");
        })
        .catch((err: any) => {
          //message.error(err.response?.data?.error);
        });

      authSVC
        .yearlyMoodOverview({ company: getUserByID?.company,department: TeamName, year: year })
        .then((res) => {
          const isDemo = JSON.parse(localStorage.getItem("Demo_check") ?? "false");
          const staticMood = {
            Avg: [
              { day: "Jan", avg: 1.1 },
              { day: "Feb", avg: 1.3 },
              { day: "Mar", avg: 1.5 },
              { day: "Apr", avg: 1.7 },
              { day: "May", avg: 2 },
              { day: "Jun", avg: 2.4 },
              { day: "Jul", avg: null },
              { day: "Aug", avg: null },
              { day: "Sep", avg: null },
              { day: "Oct", avg: null },
              { day: "Nov", avg: null },
              { day: "Dec", avg: null },
            ],
            color: "#EB228A",
          };
          setYearlyMoodOverview(isDemo ? staticMood : res?.data);
          console.log(res?.data, "setYearlyMoodOverview");
        })
        .catch((err) => {
          console.log(err);
        });

      authSVC
        .yearlyDepartmentIndexes({ reportFor: "wellness" })
        .then((res: any) => {
          setWellnessDeptChartData(res?.data?.data);
        })
        .catch((err: any) => {
          console.log(err);
        });

      authSVC
        .yearlyDepartmentIndexes({ reportFor: "happiness" })
        .then((res: any) => {
          setHappinessDeptChartData(res?.data?.data);
        })
        .catch((err: any) => {
          console.log(err);
        });
    }
  }, [getUserByID, TeamName, year]);

  return (
    <div className={styles.wellness_report_main_wrapper}>
      <div className={"row back_title"}>
        <Image
          src="/img/new/back_arrow.svg"
          preview={false}
          onClick={() => navigate("/insights")}
        />
        <p>{TeamName} Team Wellness</p>
      </div>
      <div className="year_selection_wrapper">
        <div className="flex gap-4 mt-2">
          <button
            className="px-4 py-2 bg-red-500 text-white rounded-lg"
            onClick={() => changeYear(-1)}
          >
            <img
              src="/img/arrowRight_rounded.svg"
              alt=""
              width={20}
              height={20}
            />
          </button>
          <h2 className="text-xl font-bold">Year: {year}</h2>
          <button
            className="px-4 py-2 bg-green-500 text-white rounded-lg"
            onClick={() => changeYear(1)}
          >
            <img
              src="/img/arrowLeft_rounded.svg"
              alt=""
              width={20}
              height={20}
            />
          </button>
        </div>
      </div>
      <div className="top_info">
        <img src="/img/Group19216.svg" alt="" />{" "}
        <p>A lower index value indicates a less confused mental state.</p>
      </div>
      <div className={styles.col_2_div} style={{ alignItems: "stretch" }}>
        {/* Left Container */}
        <div className={styles.data_container} style={{ display: "flex" }}>
          <div className={styles.white_bg_wrapper} style={{ width: "100%" }}>
            <div className={styles.info_title}>
              <div className="overview-card__header">
                <div className="overview-card__title-row">
                  <span
                    className="overview-card__dot"
                    style={{ background: "#5bbcb0" }}
                  />
                  <h3 className="overview-card__title">Wellness Index</h3>
                </div>
                <div className="overview-card__trend">
                  <Image src="/figma/up_arrow.svg" preview={false} width={14} />
                  <span>
                    {yearlyWellnessIndexes?.percentage || 0}% from last month
                  </span>
                </div>
              </div>
              <div className={styles.graph}>
                {wellnessDeptChartData?.series?.length === 0 ? (
                  <div className="no_data_yet">
                    <img src="/img/User_empty.png" alt="" width="56" height="52" />
                    <p>No data yet</p>
                  </div>
                ) : (
                  <StackedBarWellness chartData={wellnessDeptChartData} />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* Right Container */}
        <div className={styles.data_container} style={{ display: "flex" }}>
          <div className={styles.white_bg_wrapper} style={{ width: "100%" }}>
            <div className={styles.info_title}>
              <div className="overview-card__header">
                <div className="overview-card__title-row">
                  <span
                    className="overview-card__dot"
                    style={{
                      background: "rgb(246, 239, 86)",
                      boxShadow: "0 0 0 3px rgba(0, 0, 0, 0.07)",
                    }}
                  />
                  <h3 className="overview-card__title">Happiness Index</h3>
                </div>
                <div className="overview-card__trend">
                  <Image src="/figma/up_arrow.svg" preview={false} width={14} />
                  <span>
                    {yearlyHappinessIndexes?.percentage || 0}% from last month
                  </span>
                </div>
              </div>
              <div className={styles.graph}>
                {happinessDeptChartData?.series?.length === 0 ? (
                  <div className="no_data_yet">
                    <img src="/img/User_empty.png" alt="" width="56" height="52" />
                    <p>No data yet</p>
                  </div>
                ) : (
                  <StackedBarHappiness chartData={happinessDeptChartData} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.col_2_div} style={{ alignItems: "stretch" }}>
        {/* Left Container */}
        <div className={styles.data_container} style={{ display: "flex" }}>
          <div className={styles.white_bg_wrapper} style={{ width: "100%" }}>
            <div className={styles.info_title}>
              <div className="overview-card__header">
                <div className="overview-card__title-row">
                  <span
                    className="overview-card__dot"
                    style={{ background: "#5bbcb0" }}
                  />
                  <h3 className="overview-card__title">Engagement</h3>
                </div>
                <div className="overview-card__trend">
                  <Image src="/figma/up_arrow.svg" preview={false} width={14} />
                  <span>
                    {yearlyEngagementIndexes?.percentage || 0}% from last month
                  </span>
                </div>
              </div>
              <div className={styles.graph}>
                <TeamEngagementBar chartData={yearlyEngagementIndexes} />
                {/* <BarChartHappiness chartData={barChartHappiness} /> */}
              </div>
            </div>
          </div>
        </div>
        {/* Right Container */}
        <div className={styles.data_container} style={{ display: "flex" }}>
          <div className={styles.white_bg_wrapper} style={{ width: "100%" }}>
            <div className={styles.info_title}>
              <div className={styles.title_grp}>
                {/* <Text className={styles.title}>Team Mood Overview</Text> */}
              </div>
               <div className="overview-card__header">
                <div className="overview-card__title-row">
                  <span
                    className="overview-card__dot"
                    style={{ background: "#5bbcb0" }}
                  />
                  <h3 className="overview-card__title">Team Mood Overview</h3>
                </div>
                <div className="overview-card__trend" style={{ border: "none", background: "transparent" }}>
                  <span style={{ color: "#FFF", border: "none" }}>
                    {yearlyEngagementIndexes?.percentage || 0}% from last month
                  </span>
                </div>
              </div>
              <div className={styles.graph}>
                <MoodLineChart chartData={yearlyMoodOverview} />
                {/* <BarChartHappiness chartData={barChartHappiness} /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.border}></div>
    </div>
  );
}

export default InsightsSingle;
